import { useState } from 'react';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

import Header from 'components/Headers/Header.js';
import GerenciamentoEmailAta from './GerenciamentoEmails/GerenciamentoEmailAta';
import GerenciamentoEmailProduto from './GerenciamentoEmails/GerenciamentoEmailProduto';

type TipoGerenciamentoEmail = 'ATA' | 'PRODUTO';

export default function GerenciamentoEmail(): JSX.Element {
  const [tipo, setTipo] = useState<TipoGerenciamentoEmail | ''>('');

  const COMPONENTES_TIPO = {
    ATA: GerenciamentoEmailAta,
    PRODUTO: GerenciamentoEmailProduto,
  };

  const ComponenteTipo = tipo ? COMPONENTES_TIPO[tipo] : null;

  return (
    <>
      <Header showCards={false} />

      <Container className="mt--7" fluid>
        <Row>
          <Col>
            <Card>
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <Col>
                    <h3 className="mb-0">Gerenciamento de E-mails</h3>
                  </Col>

                  <Col md="2">
                    <FormControl variant="outlined" size="small" fullWidth>
                      <InputLabel>Selecione o tipo</InputLabel>

                      <Select
                        value={tipo}
                        onChange={event => {
                          setTipo(event.target.value as TipoGerenciamentoEmail);
                        }}
                        label="Selecione o tipo"
                      >
                        <MenuItem value="ATA">Ata</MenuItem>

                        <MenuItem value="PRODUTO">Produto</MenuItem>
                      </Select>
                    </FormControl>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody>
                {ComponenteTipo && <ComponenteTipo tipo={tipo} />}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
